module.exports = "<div class=\"loadingPage\">\r\n  <fa name=\"spinner\" animation=\"spin\"></fa>\r\n</div>"